




































































/** @format */

import { Vue, Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
import { cloneDeep } from 'lodash';
import Utils from '@root/utils/common';
// axios请求
import { monthCardSendSms } from '@/api/fixed-car-management';
import * as _ from 'lodash';
// form表单项定义
export interface IForm {
  multipleSmsId: string;
  singleSmsId: string;
}

@Component({
  name: 'ManualPushSms',
  components: {}
})
export default class ManualPushSms extends Mixins(TableMixin, TableWidthMixin) {
  @Prop({ default: () => {} })
  dataForm!: any;

  @Prop({ type: Boolean, default: false })
  isvisible!: boolean;

  @Prop({ default: [] })
  optionList!: any;
  tableData = [];
  tableLoading = false;
  // 表单
  form: any = null;
  spinning: boolean = false;
  smsg: string = '';
  mmsg: string = '';
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.total = this.dataForm.length || 0;
    //this.tableData = this.dataForm
  }
  @Watch('isvisible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  closeModelSub() {
    this.$emit('closeModel');
  }

  // 初始化form表单
  init() {
    this.tableData = this.dataForm;
    let singleResult: any = [];
    singleResult = _.filter(this.optionList, function(o) {
      return o.name.indexOf('单卡') > -1;
    });
    let multiResult: any = [];
    multiResult = _.filter(this.optionList, function(o) {
      return o.name.indexOf('多卡') > -1;
    });
    this.smsg = singleResult.length > 0 ? singleResult[0].content : '';
    this.mmsg = multiResult.length > 0 ? multiResult[0].content : '';
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          singleSmsId: this.$form.createFormField({
            value: singleResult.length > 0 ? singleResult[0].pkSms : ''
          }),
          multipleSmsId: this.$form.createFormField({
            value: multiResult.length > 0 ? multiResult[0].pkSms : ''
          })
        };
      }
    });
  }

  // 提交监听处理
  async handleSubmit(e: any) {
    // console.log(e)
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.onAddOrEdit({ ...values });
      }
    });
  }
  // 提交请求发送添加

  // 添加和编辑
  async onAddOrEdit(values: IForm) {
    // TIP: 和后端沟通接口返回ID给前端
    if (this.spinning) return;
    this.spinning = true;
    try {
      let json = [];
      this.tableData.forEach(item => {
        json.push({ ...item, ...values, spaceCode: item.code || '' });
      });
      const res = await monthCardSendSms([...json]);
      this.$message.success(`推送成功`);
      // 提交成功保存返回ID，再添加列表的编辑功能中有用
      this.$emit('okModel');
      this.form.resetFields();
    } catch (e) {
      this.$message.error((e && e.msg) || `推送失败`);
    } finally {
      this.spinning = false;
    }
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '姓名',
        dataIndex: 'userName',
        width: 100,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '手机号',
        dataIndex: 'phoneNum',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      }
    ];
  }
  async fetchTableData() {
    if (this.total < (this.current - 1) * this.pageSize) {
      this.current = 1;
    }
    const startIndex = (this.current - 1) * this.pageSize;
    this.tableData = this.dataForm.slice(startIndex, startIndex + this.pageSize);
  }
}
